import { select, Store } from '@ngrx/store';
import { debounceTime } from 'rxjs/operators';
import { MatPaginator } from '@angular/material/paginator';
import { AppState } from '../../../../core/reducers';
import { BaseDataSource, QueryResultsModel } from '../../../../core/_base/crud';
import { AccessHistory } from '../models';
import {
  selectAccessHistoryPage,
  selectAccessHistoryPageLoading,
  selectAccessHistoryShowInitWaitingMessage,
} from '../selectors';

export class AccessHistoryDataSource extends BaseDataSource {
  private _accessHistories: AccessHistory[];

  constructor(private store: Store<AppState>, private paginator: MatPaginator) {
    super();

    this.loading$ = this.store.select(selectAccessHistoryPageLoading);
    this.isPreloadTextViewed$ = this.store.select(selectAccessHistoryShowInitWaitingMessage);

    this.store
      .pipe(select(selectAccessHistoryPage), debounceTime(500))
      .subscribe((res: QueryResultsModel) => {
        this._accessHistories = res.items;

        this.entitySubject.next(res.items.slice(0, this.paginator.pageSize));
        this.paginatorTotalSubject.next(res.totalCount);
      });
  }

  get accessHistories() {
    return this._accessHistories;
  }
}
